var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-principal-container",class:_vm.clazz},[_c('h1',{staticClass:"title",class:_vm.titleClazz},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("specialTitle")],2),(_vm.subtitle)?_c('p',{staticClass:"subtitle",class:_vm.subtitleClazz},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }